import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { BasketPxDetailsAC } from './AC/BasketPxDetails.AC';
import { BasketPxDetailsOV } from './OV/BasketPxDetails.OV';
import { BasketPxDetailsAP } from './AP/BasketPxDetails.AP';
import { BasketPxDetailsDS } from './DS/BasketPxDetails.DS';
import { BasketPxDetailsOV as BasketPxDetailsOV_GB } from './OV/GB/BasketPxDetails.OV';
import { BasketPxDetailsStyled } from './BasketPxDetailsStyled';
import { SC } from '../../styles/theme';

export type BasketPxDetailsProps = SC & {
    generatedIndex?: number;
};

const BasketPxDetails = (props: BasketPxDetailsProps) => {
    if (BRAND === 'AC') return <BasketPxDetailsAC {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <BasketPxDetailsOV_GB {...props} /> : <BasketPxDetailsOV {...props} />;
    if (BRAND === 'AP') return <BasketPxDetailsAP {...props} />;
    if (BRAND === 'DS') return <BasketPxDetailsDS {...props} />;
    return <BasketPxDetailsStyled {...props} />;
};

export default BasketPxDetails;
